module.exports = __webpack_public_path__ + "static/media/5.98df62e8.jpg";